import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "user-header" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "user-header__wrapper" }
const _hoisted_4 = { class: "user-header__left" }
const _hoisted_5 = { class: "user-header__logo-wrapper" }
const _hoisted_6 = { class: "user-header__link-list" }
const _hoisted_7 = { class: "user-header__link-item" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Fiókom")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Áttekintés")
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<li class=\"user-header__link-item\"><a href=\"https://rtl.hu\" class=\"user-header__link\"> RTL.hu címlap <svg width=\"13\" height=\"13\" viewBox=\"0 0 13 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1 0V2H9.59L0 11.59L1.41 13L11 3.41V12H13V0H1Z\" fill=\"#515258\"></path></svg></a></li><li class=\"user-header__link-item\"><a href=\"https://rtlplusz.hu\" class=\"user-header__link\"> RTL+ <svg width=\"13\" height=\"13\" viewBox=\"0 0 13 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1 0V2H9.59L0 11.59L1.41 13L11 3.41V12H13V0H1Z\" fill=\"#515258\"></path></svg></a></li>", 2)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn.rtl.hu/5e/1c/kovacs-angel-marianna_image_842af88feb9c6aea71854c4cd2f2?size=w320",
  alt: "",
  class: "user-header__user-image"
}, null, -1)
const _hoisted_13 = { class: "user-header__user-text" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Üdvözlünk,")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "user-header__user-name" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_21 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { class: "user-mobile-menu__logo-wrapper" }
const _hoisted_23 = {
  key: 0,
  class: "user-mobile-menu__user"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn.rtl.hu/5e/1c/kovacs-angel-marianna_image_842af88feb9c6aea71854c4cd2f2?size=w320",
  alt: "",
  class: "user-mobile-menu__user-image"
}, null, -1)
const _hoisted_25 = { class: "user-mobile-menu__user-text" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Üdvözlünk,")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = { class: "user-mobile-menu__user-name" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Áttekintés")
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<a href=\"https://rtl.hu\" class=\"user-mobile-menu__link\"> RTL.hu címlap <svg width=\"13\" height=\"13\" viewBox=\"0 0 13 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1 0V2H9.59L0 11.59L1.41 13L11 3.41V12H13V0H1Z\" fill=\"#515258\"></path></svg></a><a href=\"https://rtlplusz.hu\" class=\"user-mobile-menu__link\"> RTL+ <svg width=\"13\" height=\"13\" viewBox=\"0 0 13 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1 0V2H9.59L0 11.59L1.41 13L11 3.41V12H13V0H1Z\" fill=\"#515258\"></path></svg></a>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_main_logo = _resolveComponent("main-logo")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, { to: { name: 'index' } }, {
              default: _withCtx(() => [
                _createVNode(_component_main_logo)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", _hoisted_7, [
              (_ctx.user)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: { name: 'personalDataDef' },
                    class: "user-header__link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: { name: 'index' },
                    class: "user-header__link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }))
            ]),
            _hoisted_10
          ])
        ]),
        (_ctx.user)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/fiokom",
              class: "user-header__right"
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _hoisted_15,
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.user.profile.lastName) + " " + _toDisplayString(_ctx.user.profile.firstName), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["user-header__mobile-toggle", { 'user-header__mobile-toggle--open': _ctx.isNavOpen }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleMobileMenu()))
        }, _hoisted_21, 2)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["navbar-mobile-backdrop", { 'navbar-mobile-backdrop--open': _ctx.isNavOpen }])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["user-mobile-menu", { 'user-mobile-menu--open': _ctx.isNavOpen }])
      }, [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_main_logo)
        ]),
        (_ctx.user)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _hoisted_27,
                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.user.profile.lastName) + " " + _toDisplayString(_ctx.user.profile.firstName), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          href: "",
          to: { name: 'index' },
          class: "user-mobile-menu__link"
        }, {
          default: _withCtx(() => [
            _hoisted_29
          ]),
          _: 1
        }),
        _hoisted_30
      ], 2)
    ])
  ]))
}